var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsEnabledNeverLoggedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10C19.994 4.48 15.52.006 10 0zm2.083 15.11a.417.417 0 0 1-.41.476h-3.58a.417.417 0 0 1-.408-.495l1.046-4.883a2.857 2.857 0 0 1 .577-5.375 2.91 2.91 0 0 1 3.609 2.792 2.866 2.866 0 0 1-1.649 2.583l.815 4.901z",
    fill: "#F94000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsEnabledNeverLoggedIn);
export default __webpack_public_path__ + "static/media/accounts-enabled-never-logged-in.65d957d1a6ac49dea6e5cf4eb79d75ab.svg";
export { ForwardRef as ReactComponent };